
export const footerLinks = [
  {
    title: 'BestBuy.com',
    url: 'https://www.bestbuy.com/',
    target: true
  },
  {
    title: 'Corporate Information',
    url: 'https://corporate.bestbuy.com/',
    target: true
  },
  {
    title: 'Partner Portal',
    url: 'https://partners.bestbuy.com/-/bestbuy-ads-term-policies-guidelines',
    target: true
  },
  {
    title: 'Conditions of Use',
    url: 'https://www.bestbuy.com/site/help-topics/terms-and-conditions/pcmcat204400050067.c?id=pcmcat204400050067',
    target: true
  },
  {
    title: 'Privacy',
    url: 'https://www.bestbuy.com/site/help-topics/privacy-policy/pcmcat204400050062.c?id=pcmcat204400050062',
    target: true
  },
  {
    title: 'Online Analytics Policy',
    url: '/oa-policy',
    target: false
  },
];

export const footerProps = [
  {
    screen: '/',
    footerBanner: '/images/footer/footer_see-whats-possible.png',
    footerBannerMobile: '/images/footer/footer_see-whats-possible_mobile.png',
    footerTitle: 'See what’s possible.',
    ctaText: "Let's get started",
    ctaUrl: '/lets-talk'
  },
  {
    screen: '/audience',
    footerBanner: '/images/footer/footer_journey.png',
    footerBannerMobile: '/images/footer/footer_journey_mobile.png',
    footerTitle: 'Join us on a different kind of journey.',
    ctaText: 'Learn more about our solution',
    ctaUrl: '/solutions'
  },
  {
    screen: '/solutions',
    footerBanner: '/images/footer/footer_see-whats-possible.png',
    footerBannerMobile: '/images/footer/footer_see-whats-possible_mobile.png',
    footerTitle: 'See what’s possible.',
    ctaText: 'Let’s get started',
    ctaUrl: '/lets-talk'
  },
  {
    screen: '/lets-talk',
    footerBanner: '/images/footer/footer_whats-next.png',
    footerBannerMobile: '/images/footer/footer_whats-next_mobile.png',
    footerTitle: 'What’s next?',
    ctaText: 'See our results',
    ctaUrl: '/success-story'
  },
  {
    screen: '/success-story',
    footerBanner: '/images/footer/footer_see-whats-possible.png',
    footerBannerMobile: '/images/footer/footer_see-whats-possible_mobile.png',
    footerTitle: 'See what’s possible.',
    ctaText: 'Let’s get started',
    ctaUrl: '/lets-talk'
  },
  {
    screen: '/intel-ideas',
    footerBanner: '/images/footer/footer_see-whats-possible.png',
    footerBannerMobile: '/images/footer/footer_see-whats-possible_mobile.png',
    footerTitle: 'See what’s possible.',
    ctaText: 'Let’s get started',
    ctaUrl: '/lets-talk'
  },
  {
    screen: '/whats-news',
    footerBanner: '/images/footer/footer_see-whats-possible.png',
    footerBannerMobile: '/images/footer/footer_see-whats-possible_mobile.png',
    footerTitle: 'See what’s possible.',
    ctaText: 'Let’s get started',
    ctaUrl: '/lets-talk'
  },
  {
    screen: '/thank-you',
    footerBanner: '/images/footer/footer_whats-next.png',
    footerBannerMobile: '/images/footer/footer_whats-next_mobile.png',
    footerTitle: 'What’s next?',
    ctaText: 'Let’s get started',
    ctaUrl: '/lets-talk'
  },
]

export const defaultFooterProps = footerProps[0];



export const altLtGray = "#F0F0F0";
export const techBlack = "#1D252C";
export const bgYellow = "#FFF100";

export const infoData = [
  {
    title: 'A trusted source.',
    text: 'With an approximately 90% revenue identification rate and deep customer relationships, Best Buy is known for being the helpful and inspiring partner for all things tech.'
  },
  {
    title: 'Data rich in every way.',
    text: 'Every interaction builds our understanding of what customers need, want and love. Every page viewed and video played creates a rich profile of audiences’ objectives, interests and intent for an unparalleled level of understanding.'
  },
  {
    title: 'The right foundation.',
    text: 'With our insights and reputation, you’re not just building sales in brand-safe environments, you’re building brand loyalty and trust.'
  }
];

export const cesInfoData = [
  {
    title: 'Reporting & Measurement',
    text: ''
  },
  {
    title: 'Advanced Campaign Planning',
    text: 'We are working to maximize incremental ROI for our advertisers by aligning media strategies closely with performance outcomes. Our vision is to evolve this into a self-service platform, giving advertisers direct access to optimize their own media strategies with the same ROI-focused insights.'
  },
  {
    title: 'Ad Exposure',
    text: 'Unlock insights into how ads within the Best Buy ecosystem influence shopper behavior to move them further down the purchase funnel. By leveraging these insights, we can continually enhance campaign effectiveness, driving higher incremental ROI.'
  }
];
//AIzaSyBNpkKH2avyfUclgt3i8020WCFbRBG5lHc - client
//6LeEjZUqAAAAAF9XlwYZ_fJnQ4rumrML1szdUdJ6 - satya
export const RECAPTCHA_SITE_KEY = process.env.RECAPTCHA_SITE_KEY || "6LeEjZUqAAAAAF9XlwYZ_fJnQ4rumrML1szdUdJ6";

export const adsBrand = {
  branded: {
    hero: {
      "image_url": "/images/adsLandingPages/Branded_BestBuyAds.png",
      "title": "Join our team on a different kind of journey.",
      "paragraphs": [
        "At Best Buy Ads, we connect our consumer electronics (CE) brand partners to highly engaged audiences—all thanks to deep customer relationships from the #1 consumer tech specialty retailer.",
        "Using our robust insights and full suite of advertising solutions, you can inspire, influence and unlock next-level possibilities in every moment."
      ]
    },
    thankMessage: "You’ve taken the first step to retail media success–we’ll be in touch soon."
  },
  competitors: {
    hero: {
      "image_url": "/images/adsLandingPages/Branded_Competitors.png",
      "title": "Retail media for consumer electronics.",
      "paragraphs": [
        "At Best Buy Ads, our deep relationships with consumer electronics (CE) customers are what make us unlike any other retail media network.", "We connect our brand partners to highly engaged tech audiences at every stage of the customer journey—all thanks to the #1 consumer tech specialty retailer.", "Using our robust insights and a full suite of advertising solutions, you can inspire, influence and unlock next-level possibilities in every moment. "
      ]
    },
    thankMessage: "A Best Buy Ads expert will be in touch with you soon."
  },
  audience: {
    hero: {
      "image_url": "/images/adsLandingPages/NonBranded_Audiences.png",
      "title": "Connect with tech audiences across the customer journey.",
      "paragraphs": [
        "At Best Buy Ads, we connect our consumer electronics (CE) brand partners to highly engaged audiences—all thanks to deep customer relationships from the #1 consumer tech specialty retailer.", "Using our robust insights and a full suite of advertising solutions, you can inspire, influence and unlock next-level possibilities in every moment."
      ]
    },
    thankMessage: "We’ll be in touch soon to introduce you to our audiences."
  },
  solutions: {
    hero: {
      "image_url": "/images/adsLandingPages/NonBranded_Solutions.png",
      "title": "Explore a full suite of retail media solutions.",
      "paragraphs": [
        "At Best Buy Ads, we connect our consumer electronics (CE) brand partners to highly engaged audiences—all thanks to deep customer relationships from the #1 consumer tech specialty retailer.", "Using our robust insights and advertising solutions, you can inspire, influence and unlock next-level possibilities in every moment."
      ]
    },
    thankMessage: "We’ll be in touch soon to show you our solutions in action."
  },
}